import React, { useContext } from "react";
import { useSiteConfig } from "../context/SiteConfigContext";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaPinterest,
  FaTiktok,
  FaTwitter,
  FaYoast,
  FaYoutube,
} from "react-icons/fa";
import { CategoryContext } from "../context/CategoryContext";
import SocialLinks from "./SocialLinks";

function Footer() {
  const { config } = useSiteConfig();
  const { categories } = useContext(CategoryContext);

  // Scroll to Top Function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <footer className="skin-footer">
        {/* Background Decor (Watermark) */}

        <div className="container position-relative z-2">
          <div className="row g-4 justify-content-between">
            {/* 2. Column: Mission Statement */}
            <div className="col-lg-4 col-md-6 mb-4 mb-md-0">
              <h5 className="footer-head">Top Trend Ayurveda</h5>
              <p className="footer-desc">{config?.shortDescription}</p>

              <div className="footer-socials">
                <SocialLinks socialMedia={config?.socialMedia} />
              </div>
            </div>

            {/* 3. Column: Shop Links */}
            <div className="col-lg-2 col-md-3 col-6">
              <h5 className="footer-head">Quick Links</h5>
              <ul className="footer-links">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/shop">Shop</Link>
                </li>
                <li>
                  <Link to="/about-us">About Us</Link>
                </li>
                <li>
                  <Link to="/contact-us">Contact Us</Link>
                </li>
                <li>
                  <Link to="/manufacturing">Manufacturing</Link>
                </li>
              </ul>
            </div>

            {/* 4. Column: Support Links */}
            <div className="col-lg-2 col-md-3 col-6">
              <h5 className="footer-head">Customer Care</h5>
              <ul className="footer-links">
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms-and-conditions">Terms & Conditions</Link>
                </li>
                <li>
                  <Link to="/research-and-development">
                    Research & Development
                  </Link>
                </li>
                <li>
                  <Link to="/clinic">Clinic</Link>
                </li>
              </ul>
            </div>

            {/* 5. Column: Newsletter (Mini) */}
            <div className="col-lg-3 col-md-12">
              <div className="newsletter-box">
                <h5 className="footer-head">Deparments</h5>

                {/* <ul className="footer-links">
                  <li>
                    <Link to="">
                      Liver Diseases
                    </Link>
                  </li>
                  <li>
                    <Link to="">Infertility</Link>
                  </li>
                  <li>
                    <Link to="">High Blood Pressure</Link>
                  </li>
                  <li>
                    <Link to="">Diabetes</Link>
                  </li>
                  <li>
                    <Link to="">
                    Cancer Diseases
                    </Link>
                  </li>
                  <li>
                    <Link to="">Heart Diseases</Link>
                  </li>
                    <li>
                    <Link to="">Kidney Diseases</Link>
                  </li>
                  <li>
                    <Link to="">Thyroid</Link>
                  </li>
                    <li>
                    <Link to="">Anorectal</Link>
                  </li>
                </ul> */}

                <ul className="footer-links">
                  {categories.map((cat) => (
                    <Link
                      key={cat._id}
                      to={`/categories/${cat.slugPath}`}
                      // className="ax-dropdown-item"
                    >
                      <li>
                        {cat.name}
                        <ArrowRight size={16} />
                      </li>
                    </Link>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="footer-divider"></div>

          {/* 6. Bottom Bar */}
          <div className="row align-items-center bottom-bar">
            <div className="col-md-6 text-center text-md-start">
              <p className="copyright">
                All Rights Reserved © 2026 TOP TREND AYURVEDA
              </p>
            </div>
            <div className="col-md-6 text-center text-md-end">
              <div className="floating-logo">
                <a
                  href="https://axesell.com"
                  className="floating-designer-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="floating-content">
                    <img
                      src="/images/axesell_logo.png"
                      className="floating-icon"
                    />
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Unique "Leaf" Scroll to Top Button */}
        <button
          onClick={scrollToTop}
          className="scroll-leaf-btn"
          aria-label="Scroll to top"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 19V5M12 5L5 12M12 5L19 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </footer>
    </>
  );
}

export default Footer;
